<div class="modal-header">
    <h4 class="modal-title fw-bold">
        <span jhiTranslate="edit-basic-details.title"></span>
    </h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="clear()">
    </button>
</div>
<div class="container">
	<div class="modal-body">
		<form name="form" #f="ngForm" class="form-horizontal">
			<div class="mb-3 row required">
				<label class="col-sm-4 col-form-label fw-bold" jhiTranslate="edit-basic-details.germplasm-location">Germplasm Location</label>
				<div class="col-sm-8">
					<jhi-locations-select [(value)]="germplasm.breedingLocationId" [showFilterOptions]="true" [clearable]="false"></jhi-locations-select>
				</div>
			</div>
			<div class="mb-3 row required">
				<label class="col-sm-4 col-form-label fw-bold" jhiTranslate="edit-basic-details.germplasm-date">Germplasm Date</label>
				<div class="col-sm-8">
                    <div class="input-group">
                        <input class="form-control" [placeholder]="'global.date.placeholder' | translate" [(ngModel)]="germplasmDate"
                               ngbDatepicker #date="ngbDatepicker" id="date" name="date" required/>
                        <button class="btn btn-outline-secondary calendar" (click)="date.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                    </div>
                </div>
			</div>
			<div class="mb-3 row">
				<label class="col-sm-4 col-form-label fw-bold" jhiTranslate="edit-basic-details.reference">Reference</label>
				<div class="col-sm-8">
					<input type="text" class="form-control" name="reference" [(ngModel)]="germplasm.reference" jhi-forbiddenCharactersValidator maxlength="255"/>
				</div>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button (click)="clear()" type="submit" class="btn btn-secondary" value="Cancel">
			<span class="fa fa-ban"></span>&nbsp;{{ 'cancel' | translate }}
		</button>
		<button (click)="updateGermplasmBasicDetails()" [disabled]="!isFormValid(f)" class="btn btn-primary">
			<span *ngIf="isLoading" class="throbber throbber-btn"></span>
			<span class="fa fa-save"></span>&nbsp;
			<span jhiTranslate="update"></span>
		</button>
	</div>
</div>
